(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    // Function to truncate HTML content while preserving formatting
    function truncateHtml(element, maxLength) {
        const originalContent = element.innerHTML;
        const textContent = element.textContent || element.innerText || '';
        
        if (textContent.length <= maxLength) {
            return; // No truncation needed
        }
        
        // Create a temporary element to work with
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = originalContent;
        
        let currentLength = 0;
        let truncatedContent = '';
        
        function processNode(node) {
            if (currentLength >= maxLength) return;
            
            if (node.nodeType === Node.TEXT_NODE) {
                const remainingLength = maxLength - currentLength;
                const text = node.textContent;
                
                if (text.length <= remainingLength) {
                    truncatedContent += text;
                    currentLength += text.length;
                } else {
                    truncatedContent += text.substring(0, remainingLength) + '...';
                    currentLength = maxLength;
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                const tagName = node.tagName.toLowerCase();
                truncatedContent += '<' + tagName;
                
                // Copy attributes
                for (let i = 0; i < node.attributes.length; i++) {
                    const attr = node.attributes[i];
                    truncatedContent += ' ' + attr.name + '="' + attr.value + '"';
                }
                
                truncatedContent += '>';
                
                // Process child nodes
                for (let i = 0; i < node.childNodes.length && currentLength < maxLength; i++) {
                    processNode(node.childNodes[i]);
                }
                
                truncatedContent += '</' + tagName + '>';
            }
        }
        
        // Process all child nodes
        for (let i = 0; i < tempDiv.childNodes.length && currentLength < maxLength; i++) {
            processNode(tempDiv.childNodes[i]);
        }
        
        element.innerHTML = truncatedContent;
    }
    
    // Apply truncation to all truncated text elements
    const truncatedElements = document.querySelectorAll('.hd-js-t');
    truncatedElements.forEach(function(element) {
        truncateHtml(element, 285);
    });
    
    // Handle read less functionality (read more is handled by existing theme.js)
    const readLessBtns = document.querySelectorAll('.read-less-btn');
    
    readLessBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Remove active class to collapse the content
            const container = this.closest('.ds-t');
            container.classList.remove('active');
        });
    });
});

  } catch(e) { console.error(e); }
})();
})();
